import { Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import {
  useStartDeploymentGroup,
  useStopDeploymentGroup
} from '@/queries/deploymentGroupQueries'
import { DeploymentGroup } from '@/types/deploymentGroup'
import { GroupCameraList } from './GroupCameraList'
import { GroupConfirmModal } from './GroupConfirmModal'
import { getGroupCameraNames } from './deploymentTreeHelpers'
import { DeploymentTreeGroupContext } from './deploymentTreeTypes'
import { useRunDeploymentAction } from './useRunDeploymentAction'

type GroupPauseConfirmProps = {
  opened: boolean
  group: DeploymentGroup
  context: DeploymentTreeGroupContext
  isPaused: boolean
  onClose: () => void
}

export const GroupPauseConfirm = ({
  opened,
  group,
  context,
  isPaused,
  onClose
}: GroupPauseConfirmProps) => {
  const { mutateAsync: stopGroup, isPending: isPausing } =
    useStopDeploymentGroup()
  const { mutateAsync: startGroup, isPending: isResuming } =
    useStartDeploymentGroup()
  const run = useRunDeploymentAction(onClose)

  const action = isPaused ? 'resume' : 'pause'
  const names = getGroupCameraNames(group, context.device)

  const handleConfirm = () =>
    void run(() => (isPaused ? startGroup(group.id) : stopGroup(group.id)), {
      inProgress: `deployments.groups.actions.${action}.inProgress`,
      error: `deployments.groups.actions.${action}.error`
    })

  return (
    <GroupConfirmModal
      opened={opened}
      title={
        <FormattedMessage id={`deployments.groups.actions.${action}.title`} />
      }
      confirmLabel={
        <FormattedMessage id={`deployments.groups.actions.${action}.title`} />
      }
      isPending={isPausing || isResuming}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <Text size="sm">
        <FormattedMessage
          id={`deployments.groups.actions.${action}.confirmation`}
          values={{
            number: context.label,
            device: context.deviceName,
            count: names.length
          }}
        />
      </Text>

      <GroupCameraList names={names} />
    </GroupConfirmModal>
  )
}
